import { createTheme } from "@mui/material/styles";
import { BUTTON_STYLES, HSV_BRAND_COLORS } from "./common";

export const hsvTheme = createTheme({
    palette: {
        primary: {
            main: HSV_BRAND_COLORS.primary,
            dark: HSV_BRAND_COLORS.blueDark,
            light: HSV_BRAND_COLORS.blueLight,
            contrastText: HSV_BRAND_COLORS.textOnBlue,
        },
        secondary: {
            main: HSV_BRAND_COLORS.secondary,
            dark: HSV_BRAND_COLORS.black,
            light: HSV_BRAND_COLORS.accent,
            contrastText: HSV_BRAND_COLORS.textOnBlue,
        },
        background: {
            default: HSV_BRAND_COLORS.backgroundPrimary,
            paper: HSV_BRAND_COLORS.white,
        },
        text: {
            primary: HSV_BRAND_COLORS.textOnWhite,
            secondary: HSV_BRAND_COLORS.textMuted,
        },
        white: HSV_BRAND_COLORS.white,
        black: HSV_BRAND_COLORS.black,
        hsvBlue: HSV_BRAND_COLORS.blue,
        hsvBlueDark: HSV_BRAND_COLORS.blueDark,
        hsvBlueLight: HSV_BRAND_COLORS.blueLight,
        hsvButtonCta: HSV_BRAND_COLORS.active,
        hsvButtonCtaHover: HSV_BRAND_COLORS.hover,
        button: BUTTON_STYLES,
    },
    typography: {
        fontFamily: "HsvSans, Arial, sans-serif",
        h1: {
            fontFamily: "HsvSans, Arial, sans-serif",
            fontWeight: 700,
            color: HSV_BRAND_COLORS.primary,
        },
        h2: {
            fontFamily: "HsvSans, Arial, sans-serif",
            fontWeight: 600,
            color: HSV_BRAND_COLORS.primary,
        },
        h3: {
            fontFamily: "HsvSans, Arial, sans-serif",
            fontWeight: 600,
            color: HSV_BRAND_COLORS.secondary,
        },
        body1: {
            fontFamily: "HsvSans, Arial, sans-serif",
        },
        button: {
            fontFamily: "HsvSans, Arial, sans-serif",
            fontWeight: 700,
            textTransform: "none",
        },
    },
    components: {
        MuiContainer: {
            styleOverrides: {
                root: {
                    backgroundColor: "transparent",
                },
            },
        },
    },
    shape: {
        borderRadius: 8,
    },
    shadows: [
        "none",
        `0px 2px 4px rgba(30, 92, 179, 0.1)`,
        `0px 4px 8px rgba(30, 92, 179, 0.12)`,
        `0px 6px 12px rgba(30, 92, 179, 0.15)`,
        `0px 8px 16px rgba(30, 92, 179, 0.18)`,
        `0px 10px 20px rgba(30, 92, 179, 0.2)`,
        `0px 12px 24px rgba(30, 92, 179, 0.22)`,
        `0px 14px 28px rgba(30, 92, 179, 0.24)`,
        `0px 16px 32px rgba(30, 92, 179, 0.26)`,
        `0px 18px 36px rgba(30, 92, 179, 0.28)`,
        `0px 20px 40px rgba(30, 92, 179, 0.3)`,
        `0px 22px 44px rgba(30, 92, 179, 0.32)`,
        `0px 24px 48px rgba(30, 92, 179, 0.34)`,
        `0px 26px 52px rgba(30, 92, 179, 0.36)`,
        `0px 28px 56px rgba(30, 92, 179, 0.38)`,
        `0px 30px 60px rgba(30, 92, 179, 0.4)`,
        `0px 32px 64px rgba(30, 92, 179, 0.42)`,
        `0px 34px 68px rgba(30, 92, 179, 0.44)`,
        `0px 36px 72px rgba(30, 92, 179, 0.46)`,
        `0px 38px 76px rgba(30, 92, 179, 0.48)`,
        `0px 40px 80px rgba(30, 92, 179, 0.5)`,
        `0px 42px 84px rgba(30, 92, 179, 0.52)`,
        `0px 44px 88px rgba(30, 92, 179, 0.54)`,
        `0px 46px 92px rgba(30, 92, 179, 0.56)`,
        `0px 48px 96px rgba(30, 92, 179, 0.58)`,
    ],
});

export { hsvTheme as theme };
